angular.module('am4')
.directive('deleteImageBlobOnLoad', function() {
    return {
        restrict: 'A',
        scope: {
            file: '=deleteImageBlobOnLoad'
        },
        link: function(scope, element) {
            element.bind('load', function() {
                delete scope.file.blob;
            });
        }
    };
});


// WEBPACK FOOTER //
// ./src/app/directives/deleteImageBlobOnLoad.js